import { kpiTargetsStore } from "../stores";

export const useKpiTargetsStore = () => kpiTargetsStore;
